import React, { FC, lazy, Suspense } from 'react';
import { Link } from 'react-router-dom';

import { getCountryDisplayName, getCurrentCountry } from '../../../utils/countries';

export type LogoProps = {
    linkTo: string;
};

const country = getCurrentCountry();
const logoImportResult = import(`../../../images/Logo.${country === 'default' ? 'ukraine' : country}`).catch(
    () => null
);
const hasLogo = logoImportResult.then((mod) => mod !== null);
const LogoCountrySpecific = lazy(() => logoImportResult.then((mod) => mod || { default: () => null }));
const Logo: FC<LogoProps> = ({ linkTo }) => {
    const [logoAvailable, setLogoAvailable] = React.useState<boolean | null>(null);

    React.useEffect(() => {
        hasLogo.then(setLogoAvailable);
    }, []);

    if (logoAvailable === false) {
        return (
            <div className={'logo-container'}>
                <h4>{getCountryDisplayName(country)}</h4>
            </div>
        );
    }

    return (
        <div className={'logo-container'}>
            <Suspense fallback={<h4>{getCountryDisplayName(country)}</h4>}>
                <Link className={'logo-link'} to={linkTo}>
                    <LogoCountrySpecific />
                </Link>
            </Suspense>
        </div>
    );
};

export default Logo;
